module.exports = __webpack_public_path__ + "static/media/custom-ex-15.ef0ab1c7.jpg";